import React, { useRef, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import deleteImage from "../../Images/deleteImage.png";
import arrowleft from "../../Images/arrowleft.png";
import arrowright from "../../Images/arrowright.png";
import shoppingbag from "../../Images/shoppingbag.png";
import CloseImg from "../../Images/CloseImg.png";
import GiftImage from "../../Images/GiftImage.png";

import { useHistory } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import { useTranslation } from "react-i18next";
import minusImage1 from "../../Images/minusImage1.png";
import plusImage1 from "../../Images/plusImage1.png";
import star from "../../Images/star.png";

import { AppContext, useAppContext } from "../../AppContext";
import { Carousel, Empty } from "antd";
import axios from "axios";

import { MyDomain } from "../../App";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function AllCategoriesCartDialog({
  MyOpen,
  onClose,
  //CartData,
  onMinusAmountCart,
  onPlusAmountCart,
  onDeleteFromCart,
  MySaveTotalPrice,
  onCreateProduct2,
  handleDivClick2,
  MyRecommendedProductsData,
}) {
  const { t, i18n } = useTranslation();

  const MinusAmountCart = (TheId, UserId, IdOfProduct) => {
    const data = {
      Id: TheId,
      UserId: UserId,
      IdOfProduct: IdOfProduct,
    };
    axios
      .post(`${MyDomain}Cart/MinusAmountCart`, data) // API URL for decrementing the cart amount
      .then((response) => {
        setCartData(response.data);

        // Extract userCart and products
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;

        setCartAmount(userCart.length);

        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};

        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }

          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });

        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });

        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );

        // Final Output
        setCartData2(result);
        setSaveTotalPrice(total);
        setSaveTotalPrice2(total);

        if (beautyClub !== null) {
          setCheckBeautyClub(true);
          setSaveTotalPrice2(total - (total * beautyClub) / 100);
          setBeautyClubData(beautyClub);
        }
      })
      .catch((error) => {});
  };
  const CreateProduct2 = (IdOfProduct) => {
    const data = {
      UserId: user?.userId,
      IdOfProduct: IdOfProduct,
      AmountOfProduct: 1, // Default to adding 1 product to the cart
    };

    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // API URL for adding products to the cart
      .then((response) => {
        setCartData(response.data);

        // Extract userCart and products
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;

        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};

        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }

          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });

        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });

        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );
        setCartData2(result);
        setSaveTotalPrice(total);
        setSaveTotalPrice2(total);

        if (beautyClub !== null) {
          setCheckBeautyClub(true);
          setSaveTotalPrice2(total - (total * beautyClub) / 100);
          setBeautyClubData(beautyClub);
        }
        setCartAmount(response.data.userCart.length);
      })
      .catch((error) => {});
  };
  const DeleteFromCart = async (
    DelproductId,
    ProductId,
    UserId,
    IdOfProduct
  ) => {
    axios
      .delete(`${MyDomain}Cart/DeleteFromCart`, {
        data: { Id: DelproductId, UserId: UserId, IdOfProduct: IdOfProduct },
      })
      .then((response) => {
        // const userCart1 = response.data?.userCart || [];
        // const products1 = response.data?.products || [];

        // setCartAmount(userCart1.length);

        // // Step 1: Group cart items by product ID and calculate total quantity, total price, and store cart IDs
        // const cartSummary = userCart1.reduce((acc, cartItem) => {
        //   const productId = cartItem.idOfProduct;
        //   const product = products1.find((product) => product.id === productId); // Find product details

        //   if (product) {
        //     if (!acc[productId]) {
        //       acc[productId] = {
        //         ...product, // Include product details
        //         totalQuantity: 0,
        //         totalPrice: 0,
        //         cartIds: [], // Array to store cart IDs
        //       };
        //     }
        //     acc[productId].totalQuantity += cartItem.amountOfProduct;
        //     acc[productId].totalPrice +=
        //       product.PriceAfterDiscount * cartItem.amountOfProduct; // Calculate total price
        //     acc[productId].cartIds.push(cartItem.id); // Add cart ID to the array
        //   }
        //   return acc;
        // }, {});

        // // Step 2: Convert the grouped object into an array
        // const summarizedCart = Object.values(cartSummary);

        // // Step 3: Calculate the total sum of all products in the cart
        // const totalCartSum = summarizedCart.reduce((total, product) => {
        //   return total + product.totalPrice;
        // }, 0);

        // setCartData2(summarizedCart);
        // setSaveTotalPrice(totalCartSum);

        // /////////////////////
        // setCartData((prevState) => ({
        //   ...prevState,
        //   products: prevState.products.filter(
        //     (product) => product.id !== ProductId
        //   ),
        //   userCart: prevState.userCart.filter(
        //     (product) => product.id !== DelproductId
        //   ),
        // }));
        // const updatedCart = CartData.userCart.filter(
        //   (product) => product.id !== DelproductId
        // );
        // //const userCart = response.data?.userCart || [];
        // const updatedCart2 = CartData.userCart.find(
        //   (product) => product.id === DelproductId
        // );
        // setCartData(response.data);
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;

        setCartAmount(userCart.length);
        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};
        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }
          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });
        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });
        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );

        // Final Output
        setCartData2(result);
        setSaveTotalPrice(total);
        setSaveTotalPrice2(total);

        if (beautyClub !== null) {
          setCheckBeautyClub(true);
          setSaveTotalPrice2(total - (total * beautyClub) / 100);
          setBeautyClubData(beautyClub);
        }
      })
      .catch((error) => {});
  };
  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  const [ProductsData, setProductsData] = useState([]);

  const handleCreateProduct = (Id) => {
    // Call the function passed from the parent component
    onCreateProduct2(Id); // Example product ID
  };
  const [CartData, setCartData] = useState([]);

  const [CartData2, setCartData2] = useState([]);

  useEffect(() => {
    GetCartData();
  }, [MyOpen]);

  const GetCartData = async () => {
    console.log("Open11");
    setCartData([]);
    setCartData2([]);
    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
      .then((response) => {
        setCartData(response.data);

        // Extract userCart and products
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;

        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};

        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }

          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });

        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });

        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );

        // Final Output
        setCartData2(result);
        setSaveTotalPrice(total);
        setSaveTotalPrice2(total);

        if (beautyClub !== null) {
          setCheckBeautyClub(true);
          setSaveTotalPrice2(total - (total * beautyClub) / 100);
          setBeautyClubData(beautyClub);
        }
      })
      .catch((error) => {
        //setResponseMessage("Error submitting data.");
      });
  };
  function RecommendedProductCard({
    id,
    productId,
    image,
    title,
    subtitle,
    price: initialPrice,
    discount: initialdiscount,
    deals,
    thedeal: initialthedeal,
    dropDown,
    isHeartClicked,
    onHeartClick,
  }) {
    const [isDivHovered, setIsDivHovered] = useState(false);
    const [isHeartHovered, setIsHeartHovered] = useState(false);
    const selectRef = useRef(null);
    const handleBlur = () => {
      selectRef.current.blur();
    };
    //DropDown
    const [price, setPrice] = useState(initialPrice);
    const [discount, setDiscount] = useState(
      initialdiscount === 0 ? null : price - (price * initialdiscount) / 100
    );
    const [thedeal, setThedeal] = useState(initialthedeal);

    const [theDiscount, setTheDiscount] = useState(initialdiscount);
    const [CartData, setCartData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
      setIsModalOpen(true);
    };
    const handleOk = () => {
      setIsModalOpen(false);
    };
    const handleCancel = () => {
      setIsModalOpen(false);
    };
    const [selectedOption, setSelectedOption] = useState(""); // Default selected option
    const dropdownRef = useRef(null); // Reference to the dropdown
    const newArray1 = ProductsData.filter(
      (item) => item.productId === productId
    );
    // Extract only the productId values
    const productDropDowns = newArray1.map((item) => item.dropDown);

    // Close dropdown if clicked outside
    useEffect(() => {
      setCartData([]);
      //event.preventDefault();
      const data = {
        UserId: user?.userId,
      };

      axios
        .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
        .then((response) => {
          setCartData(response.data);
          //showModal();
        })
        .catch((error) => {});
      setSelectedOption(productDropDowns[0]);
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false); // Close dropdown if the click is outside the dropdown
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [dropdownRef]);

    return (
      <div
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => {
          setIsDivHovered(false);
        }}
        style={{
          display: "flex",
          flexDirection: "column",
          cursor: "pointer",
          position: "relative", // Make the parent position relative for proper placement of the heart icon
          width: MyWidth <= 768 ? "45%" : MyWidth <= 1024 ? "24%" : "19.5%",

          marginRight: 20,
        }}
      >
        <div
          style={{
            backgroundColor: isDivHovered || isHeartHovered ? "white" : "",
            display: "flex",
            position: "absolute",
            top: "2px",
            right: "2px",
            padding: 3,
            borderRadius: 50,
          }}
          onClick={() => {
            CreateProduct2(id);
            //handleCreateProduct(id);
          }}
        >
          <img
            src={shoppingbag}
            alt="shoppingbag"
            style={{
              width: 20,
              height: 20,
            }}
          />
        </div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            backgroundColor: "black",
            transition: "color 0.3s ease",
            cursor: "pointer",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "#fafafa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            //flexGrow: 1,
            //height: "350px", // Ensure consistent height
          }}
          onClick={() => {
            handleDivClick2("product", productId);
          }}
        >
          <img
            src={image}
            alt={title}
            style={{
              width: "100%",
              height: "100%",
              maxHeight: 200,
              // maxHeight: "100%",
              // maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <p
          style={{
            fontSize: 15,
            marginBottom: 1,
            margin: 0,
            color: isHeartHovered ? "blue" : "",
          }}
          onClick={() => {
            handleDivClick2("product", productId);
          }}
          onMouseEnter={() => setIsHeartHovered(true)}
          onMouseLeave={() => setIsHeartHovered(false)}
        >
          {title}
        </p>
        <p
          style={{
            fontSize: 12,
            opacity: 0.5,
            margin: 0,
          }}
        >
          {subtitle}
        </p>
        <p style={{ fontSize: 12, opacity: 0.5, margin: 0 }}>{dropDown}</p>

        <div style={{ display: "flex", flexDirection: "row" }}>
          {[1, 2, 3, 4, 5].map((_, idx) => (
            <img
              key={idx}
              src={star}
              alt="star"
              style={{
                width: 8,
                height: 8,
                marginLeft: 3,
                marginBottom: 15,
              }}
            />
          ))}
        </div>
        {theDiscount === 0 ? (
          <>
            <p
              style={{
                margin: 0,
                paddingBottom: 5,
                fontSize: 15,
              }}
            >
              ₪{price}
            </p>
            <a
              style={{
                fontSize: 12,
              }}
            >
              &nbsp;
            </a>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: thedeal === 1 ? "row" : "column",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              {thedeal === 1 ? (
                <>
                  <p
                    style={{
                      margin: 0,
                      paddingBottom: 5,
                      fontSize: 15,
                      color: "red",
                    }}
                  >
                    ₪{(price - (price * theDiscount) / 100).toFixed(2)}
                  </p>
                  &nbsp; &nbsp;
                  <p
                    style={{
                      margin: 0,
                      paddingBottom: 5,
                      fontSize: 15,
                      textDecoration: "line-through",
                    }}
                  >
                    ₪{price}
                  </p>
                </>
              ) : (
                <>
                  <p
                    style={{
                      margin: 0,
                      paddingBottom: 5,
                      fontSize: 15,
                    }}
                  >
                    ₪{price}
                  </p>
                </>
              )}
            </div>
            <div>
              <a>
                <a
                  style={{
                    fontSize: 15,
                  }}
                >
                  {thedeal === 1 ? (
                    <>
                      <p
                        style={{
                          backgroundColor: "#6b21a8",
                          color: "white",
                          margin: 0,
                          marginBottom: 5,
                          paddingLeft: 5,
                          paddingRight: 5,
                          fontSize: 15,
                        }}
                      >
                        -{theDiscount}%
                      </p>
                      <a
                        style={{
                          fontSize: 12,
                        }}
                      >
                        &nbsp;
                      </a>
                    </>
                  ) : (
                    <>
                      {/* <a
                        style={{
                          backgroundColor: "#6b21a8",
                          color: "white",
                          fontSize: 12,
                          paddingLeft: 5,
                          paddingRight: 5,
                        }}
                      >
                        Buy 2 pcs to get -{theDiscount}% off every {thedeal}
                        {thedeal === 2 ? "nd" : "th"} item
                      </a> */}
                    </>
                  )}
                </a>
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }

  const [currentSlide, setCurrentSlide] = useState(0);

  const history = useHistory();

  const handleDivClick1 = (CategoryName) => {
    history.push(`/${CategoryName}`);
  };
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (
    cartItem,
    ProductAmountOfProduct,
    ProductTheDeal,
    ProductId,
    UserId,
    IdOfProduct
  ) => {
    // Call the function passed from the parent component
    onMinusAmountCart(
      cartItem,
      ProductAmountOfProduct,
      ProductTheDeal,
      ProductId,
      UserId,
      IdOfProduct
    );
  };

  const handleClick2 = (
    cartItemId,
    cartItemamountOfProduct,
    UserId,
    IdOfProduct
  ) => {
    // Call the function passed from the parent component
    onPlusAmountCart(cartItemId, cartItemamountOfProduct, UserId, IdOfProduct);
  };
  const calculateTotalPrice = (price, amount, discount, discountOnEvery) => {
    let total = 0;

    for (let i = 1; i <= amount; i++) {
      if (i % discountOnEvery === 0) {
        // Apply discount to every 'discountOnEvery' item
        total += price * (1 - discount / 100);
      } else {
        // Add full price for non-discounted items
        total += price;
      }
    }

    // Format the total to show decimals only when needed
    const formattedTotal = Number.isInteger(total)
      ? total.toString()
      : parseFloat(total.toFixed(2));

    return formattedTotal;
  };
  const handleDelete = async (cartItemId, productId, UserId, IdOfProduct) => {
    // Call the function passed from the parent component
    await onDeleteFromCart(cartItemId, productId, UserId, IdOfProduct); // Example IDs
  };

  const [currentSlide2, setCurrentSlide2] = useState(0);
  const carouselRef2 = React.createRef();
  const { CartAmount, setCartAmount } = useContext(AppContext);
  const [hoverStates, setHoverStates] = useState({}); // Store hover states for each ID
  //const [RecommendedProductsData, setRecommendedProductsData] = useState([]);

  const handleMouseEnter = (id) => {
    setHoverStates((prev) => ({ ...prev, [id]: true }));
  };

  const handleMouseLeave = (id) => {
    setHoverStates((prev) => ({ ...prev, [id]: false }));
  };
  const [SaveTotalPrice, setSaveTotalPrice] = useState(
    Number(MySaveTotalPrice)
  );
  const [SaveTotalPrice2, setSaveTotalPrice2] = useState(
    Number(MySaveTotalPrice)
  );
  const [CheckBeautyClub, setCheckBeautyClub] = useState(false);
  const [BeautyClubData, setBeautyClubData] = useState("");

  const handleDivClick4 = (CategoryName) => {
    //setOpen1(false);
    //setOpen(false);
    history.push(`/${CategoryName}`); // Navigate to the root path
  };

  const next2 = () => {
    carouselRef2.current.next();
  };

  const prev2 = () => {
    carouselRef2.current.prev();
  };
  const numItemsPerSlide = MyWidth <= 768 ? 2 : MyWidth <= 1024 ? 4 : 5; // Change this to 4 if you want 4 items per slide
  const wrapperRef2 = useRef();
  const handleBeforeChange2 = (from, to) => {
    setCurrentSlide2(to);
  };

  const chunkArray2 = (array, size) => {
    if (!Array.isArray(array) || array.length === 0) {
      return []; // Return an empty array if input is not a valid array
    }
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };
  const slides2 = chunkArray2(
    MyRecommendedProductsData.products,
    numItemsPerSlide
  ); // Grouping products into chunks of 4

  const CalcAfterDiscount = (ProductPrice, ProductDiscount, ProductTTQ) => {
    {
      /* {(product.price -(product.price * product.discount) / 100 ).toFixed(2) * product.totalQuantity.toFixed(2)} */
    }
    const TheFinal =
      (ProductPrice - (ProductPrice * ProductDiscount) / 100) * ProductTTQ;

    return <>{TheFinal.toFixed(2)}</>;
  };
  return (
    <div
      style={{
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      {MyWidth <= 1024 ? (
        <>
          <Drawer
            open={MyOpen}
            onClose={onClose}
            anchor="bottom"
            PaperProps={{
              style: {
                height: "100%", // Set the height to 100%
              },
            }}
          >
            {/* change the true to MyOpen */}
            <div
              style={{
                display: "flex",
                width: "100%",
                //justifyContent: "flex-end",
                // paddingTop: 20,
                // paddingBottom: 30,
                flexDirection: "column",
                direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                fontFamily: "Droid Arabic Kufi, sans-serif",
              }}
            >
              <p> </p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  // marginLeft: "2%",
                  // marginRight: "2%",
                  paddingBottom: 20,
                }}
              >
                <a style={{ fontSize: 20, fontWeight: "500" }}>
                  {t("profile.Cart")}
                </a>
                <img
                  onClick={() => {
                    onClose();
                  }}
                  src={CloseImg}
                  alt={"Expand"}
                  style={{ width: 25, height: 25, cursor: "pointer" }}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  //height: "calc(65vh - 55px)",
                  //height: window.height,
                  paddingBottom: 180,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    //height: "calc(70vh - 55px)",
                    height: "100%",

                    //backgroundColor: "red",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      overflow: "auto", // Enables scrolling
                    }}
                  >
                    {CartData2.map((product) => {
                      return (
                        <div style={{}}>
                          <div
                            key={product.id}
                            style={{
                              width: "100%",
                              //background: "#f0f0f0",
                              padding: "10px",
                              flexDirection: "row",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              //backgroundColor: "blue",
                            }}
                            onClick={() => {
                              //handleDivClick2("product", product.productId);
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                //backgroundColor: "gray",
                                cursor: "pointer",
                                width: "40%",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              onClick={() => {
                                handleClose();
                                handleDivClick2("product", product?.productId);
                                //handleDivClick1("product");
                              }}
                            >
                              <img
                                src={product?.image}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  maxWidth: 200,
                                  //opacity: currentSlide === 0 ? 0.3 : 1,
                                  cursor: currentSlide === 0 ? "" : "pointer",
                                  //backgroundColor: "red",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                //alignItems: "center",
                                //backgroundColor: "yellow",
                                cursor: "pointer",
                                width: "60%",
                                flexDirection: "column",
                              }}
                              onClick={() => {
                                //handleDivClick1("product");
                              }}
                            >
                              <p
                                style={{
                                  padding: 0,
                                  marginBottom: 5,
                                  fontSize: 15,
                                }}
                              >
                                {product.name}
                              </p>
                              <p
                                style={{
                                  padding: 0,
                                  margin: 0,
                                  opacity: 0.5,
                                  fontSize: 13,
                                }}
                              >
                                {product.productType}
                              </p>
                              <p
                                style={{
                                  padding: 0,
                                  margin: 0,
                                  opacity: 0.5,
                                  fontSize: 13,
                                }}
                              >
                                {product.dropDown}
                              </p>
                              {product.isGift === 2 ? (
                                <>
                                  <img
                                    src={GiftImage}
                                    style={{
                                      width: 18,
                                      height: 18,
                                    }}
                                  />
                                </>
                              ) : (
                                <></>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  //backgroundColor: "green",
                                  flexDirection: "row",
                                  paddingTop: 10,
                                  paddingBottom: 10,
                                }}
                              >
                                {product.discount === 0 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      paddingRight: "50%",
                                      //backgroundColor: "yellow",
                                      flexDirection: "row",
                                    }}
                                  >
                                    {product.priceInsteadOf === 0 ? (
                                      <>
                                        <a
                                          style={{
                                            margin: 0,
                                            //paddingBottom: 5,
                                            fontSize: 15,
                                          }}
                                        >
                                          ₪
                                          {calculateTotalPrice(
                                            product.price,
                                            product.totalQuantity,
                                            product.discount,
                                            product.theDeal
                                          )}
                                        </a>
                                      </>
                                    ) : (
                                      <>
                                        <a
                                          style={{
                                            margin: 0,
                                            //paddingBottom: 5,
                                            fontSize: 15,
                                            color: "red",
                                            textDecoration: "line-through",
                                          }}
                                        >
                                          ₪
                                          {calculateTotalPrice(
                                            product.price,
                                            product.totalQuantity,
                                            product.discount,
                                            product.theDeal
                                          )}
                                        </a>
                                        &nbsp;&nbsp;
                                        <a
                                          style={{
                                            margin: 0,
                                            //paddingBottom: 5,
                                            fontSize: 15,
                                          }}
                                        >
                                          ₪
                                          {calculateTotalPrice(
                                            product.priceInsteadOf,
                                            product.totalQuantity,
                                            product.discount,
                                            product.theDeal
                                          )}
                                        </a>
                                      </>
                                    )}

                                    <a
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      &nbsp;
                                    </a>
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      // flexDirection:
                                      //   product.theDeal === 1 ? "row" : "column",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      //alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      {product.theDeal === 1 ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          <a
                                            style={{
                                              margin: 0,
                                              // paddingBottom: 5,
                                              fontSize: 15,
                                              textDecoration: "line-through",
                                            }}
                                          >
                                            ₪
                                            {product.price *
                                              product.totalQuantity}
                                          </a>
                                          <a
                                            style={{
                                              margin: 0,
                                              //paddingBottom: 5,
                                              fontSize: 15,
                                              color: "red",
                                            }}
                                          >
                                            &nbsp;₪
                                            {(
                                              product.price -
                                              (product.price *
                                                product.discount) /
                                                100
                                            ).toFixed(2) *
                                              product.totalQuantity}
                                            &nbsp;
                                          </a>

                                          {/* &nbsp; &nbsp; */}
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          {product.totalQuantity === 1 ? (
                                            <></>
                                          ) : (
                                            <>
                                              <a
                                                style={{
                                                  margin: 0,
                                                  // paddingBottom: 5,
                                                  fontSize: 15,
                                                  textDecoration:
                                                    "line-through",
                                                  color: "black",
                                                  // color:
                                                  //   cartItem.amountOfProduct === 1
                                                  //     ? "black"
                                                  //     : "red",
                                                }}
                                              >
                                                ₪
                                                {product.price *
                                                  product.totalQuantity}
                                                &nbsp;
                                              </a>
                                              {/* &nbsp; &nbsp; */}
                                            </>
                                          )}
                                          <a
                                            style={{
                                              margin: 0,
                                              // paddingBottom: 5,
                                              fontSize: 15,
                                              //textDecoration: "line-through",
                                              color:
                                                product.totalQuantity !== 1
                                                  ? "red"
                                                  : "black",
                                            }}
                                          >
                                            ₪
                                            {calculateTotalPrice(
                                              product.price,
                                              product.totalQuantity,
                                              product.discount,
                                              product.theDeal
                                            ).toFixed(2)}
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div>
                                {product.discount === 0 ? (
                                  <></>
                                ) : (
                                  <div style={{ display: "flex" }}>
                                    <p style={{ margin: 0 }}>
                                      <a
                                        style={{
                                          fontSize: 15,
                                        }}
                                      >
                                        {product.theDeal === 1 ? (
                                          <div>
                                            <p
                                              style={{
                                                backgroundColor: "#6b21a8",
                                                color: "white",
                                                margin: 0,
                                                //marginBottom: 5,
                                                paddingLeft: 5,
                                                paddingRight: 5,
                                                fontSize: 15,
                                              }}
                                            >
                                              -{product.discount}%
                                            </p>
                                            <a
                                              style={{
                                                fontSize: 12,
                                                margin: 0,
                                              }}
                                            ></a>
                                          </div>
                                        ) : (
                                          // "Buy " + theDeal + "pcs to get -" + item.discount
                                          <>
                                            <a
                                              style={{
                                                backgroundColor: "#6b21a8",
                                                color: "white",
                                                fontSize: 12,
                                                paddingLeft: 5,
                                                paddingRight: 5,
                                              }}
                                            >
                                              Buy 2 pcs to get -
                                              {product.discount}% off every{" "}
                                              {product.theDeal}
                                              {product.theDeal === 2
                                                ? "nd"
                                                : "th"}{" "}
                                              item
                                            </a>
                                          </>
                                        )}
                                      </a>
                                    </p>
                                  </div>
                                )}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    //backgroundColor: "yellow",
                                    width: "35%",
                                  }}
                                >
                                  {product.isGift != 2 ? (
                                    <>
                                      <button
                                        title="minus"
                                        style={{
                                          padding: 5,
                                          backgroundColor: "white",
                                          border: "1px solid #e7e5e4",
                                        }}
                                      >
                                        <img
                                          src={minusImage1}
                                          style={{
                                            width: 25,
                                            height: 25,
                                            margin: 0,
                                            //opacity: currentSlide === 0 ? 0.3 : 1,
                                            cursor:
                                              currentSlide === 0
                                                ? ""
                                                : "pointer",
                                          }}
                                          onClick={() => {
                                            MinusAmountCart(
                                              product.cartIds[0],
                                              user?.userId,
                                              product.id
                                            );
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : (
                                    <div style={{ width: 35 }}></div>
                                  )}

                                  <p
                                    style={{
                                      margin: 0,
                                      paddingRight: 15,
                                      paddingLeft: 15,
                                    }}
                                  >
                                    {/* {AmountOfProduct} */}
                                    {product.totalQuantity}
                                  </p>
                                  {product.isGift != 2 ? (
                                    <>
                                      <button
                                        type="button" // Prevent default form behavior
                                        title="plus"
                                        style={{
                                          padding: 5,
                                          backgroundColor: "white",
                                          border: "1px solid #e7e5e4",
                                        }}
                                        onClick={() => {
                                          CreateProduct2(product.id);
                                        }}
                                      >
                                        <img
                                          src={plusImage1}
                                          style={{
                                            width: 25,
                                            height: 25,
                                            margin: 0,

                                            //opacity: currentSlide === 0 ? 0.3 : 1,
                                            cursor:
                                              currentSlide === 0
                                                ? ""
                                                : "pointer",
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                {product.isGift != 2 ? (
                                  <>
                                    <button
                                      title="delete"
                                      style={{
                                        backgroundColor: "white",
                                        border: "0px solid white",
                                      }}
                                    >
                                      <img
                                        src={deleteImage}
                                        style={{
                                          width: 20,
                                          height: 20,
                                          margin: 0,
                                          opacity: hoverStates[product.id]
                                            ? 1
                                            : 0.5,
                                          //opacity: isHovered ? 1 : 0.5,
                                          //transition: "opacity 0.3s ease",
                                        }}
                                        onClick={() => {
                                          DeleteFromCart(
                                            product.id,
                                            product.id,
                                            user?.userId,
                                            product.id
                                          );
                                        }}
                                        onMouseEnter={() =>
                                          handleMouseEnter(product.id)
                                        }
                                        onMouseLeave={() =>
                                          handleMouseLeave(product.id)
                                        }
                                        // onMouseEnter={() => setIsHovered(true)}
                                        // onMouseLeave={() => setIsHovered(false)}
                                      />
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              height: "0.1px",
                              backgroundColor: "#f4f4f5",
                              width: "100%",
                            }}
                          ></div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              {/* <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "flex-end",
                  //backgroundColor: "gray",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: 30,
                  }}
                  onClick={prev2}
                >
                  <img
                    src={arrowleft}
                    style={{
                      width: 35,
                      height: 35,
                      opacity: currentSlide2 === 0 ? 0.3 : 1,
                      cursor: currentSlide2 === 0 ? "" : "pointer",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={next2}
                >
                  <img
                    src={arrowright}
                    style={{
                      width: 35,
                      height: 35,
                      opacity: currentSlide2 === slides2.length - 1 ? 0.3 : 1,
                      cursor:
                        currentSlide2 === slides2.length - 1 ? "" : "pointer",
                    }}
                  />
                </div>
              </div> */}
              {/* <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                  //backgroundColor: "yellow",
                  //height: "calc(100vh - 55px)",
                  marginBottom: 150,
                }}
              >
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "row",
                    paddingBottom: 20,
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      paddingLeft: 15,
                      fontWeight: "500",
                    }}
                  >
                    {t("profile.Recommended")}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      paddingLeft: 15,
                      fontWeight: "500",
                    }}
                  >
                    {t("profile.products")}
                  </p>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    paddingLeft: 15,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      //height: "calc(100vh - 55px)",
                      direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    }}
                  >
                    <div>
                      <div ref={wrapperRef2}>
                        <Carousel
                          arrows={false}
                          infinite={false}
                          ref={carouselRef2}
                          beforeChange={handleBeforeChange2}
                          dots={false}
                        >
                          {slides2.map((slide, index) => (
                            <div>
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  //justifyContent: "space-between",
                                  justifyContent: "flex-start",
                                  width: "100%",
                                  direction:
                                    i18n.resolvedLanguage === "en" ? "" : "rtl",
                                }}
                              >
                                {slide.map((image, imgIndex) => {
                                  const globalIndex =
                                    index * numItemsPerSlide + imgIndex;
                                  return (
                                    <RecommendedProductCard
                                      key={globalIndex}
                                      id={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].id
                                      }
                                      productId={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].productId
                                      }
                                      image={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].image
                                      }
                                      title={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].name
                                      } //"Molinard Osmanthus"
                                      subtitle={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].productType
                                      } //"Eau de Parfum"
                                      price={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].price
                                      } //"₪ 19"
                                      discount={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].discount
                                      }
                                      deals={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].deals
                                      }
                                      thedeal={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].theDeal
                                      }
                                      dropDown={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].dropDown
                                      }
                                    />
                                  );
                                })}
                              </div>
                            </div>
                          ))}
                        </Carousel>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div
                style={{
                  width: "100%",
                  //height: 200,
                  height: 180,
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#fafafa",
                  justifyContent: "center",
                  //backgroundColor: "blue",
                  position: "fixed", // Fix the div to the viewport
                  bottom: "0", // Stick to the bottom
                  left: "0", // Align to the left
                }}
              >
                {CheckBeautyClub ? (
                  <>
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        width: "80%",
                        alignItems: "center",
                        justifyContent: "space-between",
                        //padding: 10,
                        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          fontSize: 15,
                          fontFamily: "Droid Arabic Kufi, sans-serif",
                        }}
                      >
                        {t("profile.Orderprice")}
                      </p>
                      <p style={{ margin: 0, fontSize: 15 }}>
                        ₪{SaveTotalPrice.toFixed(2)}
                      </p>
                    </div>
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        width: "80%",
                        alignItems: "center",
                        justifyContent: "space-between",
                        //padding: 10,
                        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                      }}
                    >
                      <a
                        style={{
                          fontFamily: "Droid Arabic Kufi, sans-serif",
                        }}
                      >
                        {t("profile.Beautyclubdiscount")}
                      </a>
                      <a>{BeautyClubData}%</a>
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    width: "80%",
                    alignItems: "center",
                    justifyContent: "space-between",
                    //padding: 10,
                    direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                  }}
                >
                  <p style={{ margin: 0, fontWeight: "bold", fontSize: 18 }}>
                    {t("profile.Totalamount")}
                  </p>
                  {CheckBeautyClub ? (
                    <>
                      <p
                        style={{
                          margin: 0,
                          fontWeight: "bold",
                          fontSize: 18,
                        }}
                      >
                        ₪{SaveTotalPrice2.toFixed(2)}
                      </p>
                    </>
                  ) : (
                    <>
                      <p
                        style={{
                          margin: 0,
                          fontWeight: "bold",
                          fontSize: 18,
                        }}
                      >
                        ₪{SaveTotalPrice.toFixed(2)}
                      </p>
                    </>
                  )}
                </div>
                <div style={{ width: "80%", padding: 10, paddingTop: 20 }}>
                  <button
                    style={{
                      backgroundColor: "#27272a",
                      width: "100%",
                      height: 50,
                      color: "white",
                      borderWidth: 0,
                    }}
                    onClick={() => {
                      handleDivClick4("checkout");
                    }}
                  >
                    {t("profile.Gotopay")}
                  </button>
                </div>
              </div>
            </div>
          </Drawer>
        </>
      ) : (
        <>
          <React.Fragment>
            {/* <Button variant="outlined" onClick={handleClickOpen}>
            Open dialog
          </Button> */}
            <BootstrapDialog
              sx={{
                height: "100vh", // Set height to 100% of the viewport height
                maxHeight: "none", // Remove any max-height restrictions
                margin: 0, // Remove default margin
                "& .MuiDialog-container": {
                  //alignItems: "flex-start", // Align dialog to the top
                },
                "& .MuiDialog-paper": {
                  margin: 0, // Remove default margin
                  height: "90%", // Ensure the paper takes full height
                  maxHeight: "none", // Remove max-height restrictions
                },
              }}
              onClose={onClose}
              aria-labelledby="customized-dialog-title"
              open={MyOpen} //MyOpen
              fullWidth
              maxWidth={false} // Disable Material-UI's default width settings
            >
              <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                <a
                  style={{
                    fontFamily: "Droid Arabic Kufi, sans-serif",
                  }}
                >
                  {t("profile.Cart")}
                </a>
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  //height: "calc(65vh - 55px)",
                  //height: window.height,
                  direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                }}
              >
                <div
                  style={{
                    width: "70%",
                    height: "calc(80vh - 55px)",
                    //backgroundColor: "red",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      overflow: "auto", // Enables scrolling
                    }}
                  >
                    {CartData2.map((product) => {
                      return (
                        <div
                          style={{
                            fontFamily: "Droid Arabic Kufi, sans-serif",
                          }}
                        >
                          <div
                            key={product.id}
                            style={{
                              width: "100%",
                              //background: "#f0f0f0",
                              padding: "10px",
                              flexDirection: "row",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              //backgroundColor: "blue",
                            }}
                            onClick={() => {
                              //handleDivClick2("product", product.productId);
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                //backgroundColor: "gray",
                                cursor: "pointer",
                                width: "40%",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              onClick={() => {
                                handleClose();
                                handleDivClick2("product", product?.productId);
                                //handleDivClick1("product");
                              }}
                            >
                              <img
                                src={product?.image}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  maxWidth: 200,
                                  //opacity: currentSlide === 0 ? 0.3 : 1,
                                  cursor: currentSlide === 0 ? "" : "pointer",
                                  //backgroundColor: "red",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                //alignItems: "center",
                                //backgroundColor: "yellow",
                                cursor: "pointer",
                                width: "60%",
                                flexDirection: "column",
                              }}
                              onClick={() => {
                                //handleDivClick1("product");
                              }}
                            >
                              <p
                                style={{
                                  padding: 0,
                                  marginBottom: 5,
                                  fontSize: 15,
                                }}
                              >
                                {product.name}
                              </p>
                              <p
                                style={{
                                  padding: 0,
                                  margin: 0,
                                  opacity: 0.5,
                                  fontSize: 13,
                                }}
                              >
                                {product.productType}
                              </p>
                              <p
                                style={{
                                  padding: 0,
                                  margin: 0,
                                  opacity: 0.5,
                                  fontSize: 13,
                                }}
                              >
                                {product.dropDown}
                              </p>
                              {product.isGift === 2 ? (
                                <>
                                  <img
                                    src={GiftImage}
                                    style={{
                                      width: 18,
                                      height: 18,
                                    }}
                                  />
                                </>
                              ) : (
                                <></>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  //backgroundColor: "green",
                                  flexDirection: "row",
                                  paddingTop: 10,
                                  paddingBottom: 10,
                                }}
                              >
                                {product.discount === 0 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      paddingRight:
                                        i18n.resolvedLanguage === "en"
                                          ? "50%"
                                          : "0%",
                                      //backgroundColor: "yellow",
                                      flexDirection: "row",
                                    }}
                                  >
                                    {product.priceInsteadOf === 0 ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          width: "100%",
                                          alignItems: "center",
                                        }}
                                      >
                                        <p
                                          style={{
                                            margin: 0,
                                            //paddingBottom: 5,
                                            fontSize: 15,
                                          }}
                                        >
                                          ₪
                                          {calculateTotalPrice(
                                            product.price,
                                            product.totalQuantity,
                                            product.discount,
                                            product.theDeal
                                          )}
                                        </p>
                                      </div>
                                    ) : (
                                      <>
                                        <p
                                          style={{
                                            margin: 0,
                                            //paddingBottom: 5,
                                            fontSize: 15,
                                            color: "red",
                                            textDecoration: "line-through",
                                          }}
                                        >
                                          ₪
                                          {calculateTotalPrice(
                                            product.price,
                                            product.totalQuantity,
                                            product.discount,
                                            product.theDeal
                                          )}
                                        </p>
                                        &nbsp;&nbsp;
                                        <p
                                          style={{
                                            margin: 0,
                                            //paddingBottom: 5,
                                            fontSize: 15,
                                          }}
                                        >
                                          ₪
                                          {calculateTotalPrice(
                                            product.priceInsteadOf,
                                            product.totalQuantity,
                                            product.discount,
                                            product.theDeal
                                          )}
                                        </p>
                                      </>
                                    )}
                                    <a
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      &nbsp;
                                    </a>
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      // flexDirection:
                                      //   product.theDeal === 1 ? "row" : "column",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      //alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      {product.theDeal === 1 ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          <a
                                            style={{
                                              margin: 0,
                                              // paddingBottom: 5,
                                              fontSize: 15,
                                              textDecoration: "line-through",
                                            }}
                                          >
                                            ₪
                                            {product.price *
                                              product.totalQuantity}
                                          </a>
                                          <a
                                            style={{
                                              margin: 0,
                                              //paddingBottom: 5,
                                              fontSize: 15,
                                              color: "red",
                                            }}
                                          >
                                            &nbsp;₪
                                            {/* {(
                                              product.price -
                                              (product.price *
                                                product.discount) /
                                                100
                                            ).toFixed(2) *
                                              product.totalQuantity.toFixed(2)} */}
                                            {CalcAfterDiscount(
                                              product.price,
                                              product.discount,
                                              product.totalQuantity
                                            )}
                                            &nbsp;
                                          </a>

                                          {/* &nbsp; &nbsp; */}
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          {product.totalQuantity === 1 ? (
                                            <></>
                                          ) : (
                                            <>
                                              <a
                                                style={{
                                                  margin: 0,
                                                  // paddingBottom: 5,
                                                  fontSize: 15,
                                                  textDecoration:
                                                    "line-through",
                                                  color: "black",
                                                  // color:
                                                  //   cartItem.amountOfProduct === 1
                                                  //     ? "black"
                                                  //     : "red",
                                                }}
                                              >
                                                ₪
                                                {product.price *
                                                  product.totalQuantity}
                                                &nbsp;
                                              </a>
                                              {/* &nbsp; &nbsp; */}
                                            </>
                                          )}
                                          <a
                                            style={{
                                              margin: 0,
                                              // paddingBottom: 5,
                                              fontSize: 15,
                                              //textDecoration: "line-through",
                                              color:
                                                product.totalQuantity !== 1
                                                  ? "red"
                                                  : "black",
                                            }}
                                          >
                                            ₪
                                            {calculateTotalPrice(
                                              product.price,
                                              product.totalQuantity,
                                              product.discount,
                                              product.theDeal
                                            ).toFixed(2)}
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div>
                                {product.discount === 0 ? (
                                  <></>
                                ) : (
                                  <div style={{ display: "flex" }}>
                                    <p style={{ margin: 0 }}>
                                      <a
                                        style={{
                                          fontSize: 15,
                                        }}
                                      >
                                        {product.theDeal === 1 ? (
                                          <div>
                                            <p
                                              style={{
                                                backgroundColor: "#6b21a8",
                                                color: "white",
                                                margin: 0,
                                                //marginBottom: 5,
                                                paddingLeft: 5,
                                                paddingRight: 5,
                                                fontSize: 15,
                                              }}
                                            >
                                              -{product.discount}%
                                            </p>
                                            <a
                                              style={{
                                                fontSize: 12,
                                                margin: 0,
                                              }}
                                            ></a>
                                          </div>
                                        ) : (
                                          // "Buy " + theDeal + "pcs to get -" + item.discount
                                          <>
                                            <a
                                              style={{
                                                backgroundColor: "#6b21a8",
                                                color: "white",
                                                fontSize: 12,
                                                paddingLeft: 5,
                                                paddingRight: 5,
                                              }}
                                            >
                                              Buy 2 pcs to get -
                                              {product.discount}% off every{" "}
                                              {product.theDeal}
                                              {product.theDeal === 2
                                                ? "nd"
                                                : "th"}{" "}
                                              item
                                            </a>
                                          </>
                                        )}
                                      </a>
                                    </p>
                                  </div>
                                )}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    //backgroundColor: "yellow",
                                    width: "35%",
                                  }}
                                >
                                  {product.isGift != 2 ? (
                                    <>
                                      <button
                                        title="minus"
                                        style={{
                                          padding: 5,
                                          backgroundColor: "white",
                                          border: "1px solid #e7e5e4",
                                        }}
                                      >
                                        <img
                                          src={minusImage1}
                                          style={{
                                            width: 25,
                                            height: 25,
                                            margin: 0,
                                            //opacity: currentSlide === 0 ? 0.3 : 1,
                                            cursor:
                                              currentSlide === 0
                                                ? ""
                                                : "pointer",
                                          }}
                                          onClick={() => {
                                            MinusAmountCart(
                                              product.cartIds[0],
                                              user?.userId,
                                              product.id
                                            );
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : (
                                    <div style={{ width: 35 }}></div>
                                  )}

                                  <p
                                    style={{
                                      margin: 0,
                                      paddingRight: 15,
                                      paddingLeft: 15,
                                    }}
                                  >
                                    {/* {AmountOfProduct} */}
                                    {product.totalQuantity}
                                  </p>
                                  {product.isGift != 2 ? (
                                    <>
                                      <button
                                        type="button" // Prevent default form behavior
                                        title="plus"
                                        style={{
                                          padding: 5,
                                          backgroundColor: "white",
                                          border: "1px solid #e7e5e4",
                                        }}
                                        onClick={() => {
                                          CreateProduct2(product.id);
                                        }}
                                      >
                                        <img
                                          src={plusImage1}
                                          style={{
                                            width: 25,
                                            height: 25,
                                            margin: 0,

                                            //opacity: currentSlide === 0 ? 0.3 : 1,
                                            cursor:
                                              currentSlide === 0
                                                ? ""
                                                : "pointer",
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                {product.isGift != 2 ? (
                                  <>
                                    <button
                                      title="delete"
                                      style={{
                                        backgroundColor: "white",
                                        border: "0px solid white",
                                      }}
                                    >
                                      <img
                                        src={deleteImage}
                                        style={{
                                          width: 20,
                                          height: 20,
                                          margin: 0,
                                          opacity: hoverStates[product.id]
                                            ? 1
                                            : 0.5,
                                          //opacity: isHovered ? 1 : 0.5,
                                          //transition: "opacity 0.3s ease",
                                        }}
                                        onClick={() => {
                                          DeleteFromCart(
                                            product.id,
                                            product.id,
                                            user?.userId,
                                            product.id
                                          );
                                        }}
                                        onMouseEnter={() =>
                                          handleMouseEnter(product.id)
                                        }
                                        onMouseLeave={() =>
                                          handleMouseLeave(product.id)
                                        }
                                        // onMouseEnter={() => setIsHovered(true)}
                                        // onMouseLeave={() => setIsHovered(false)}
                                      />
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              height: "0.1px",
                              backgroundColor: "#f4f4f5",
                              width: "100%",
                            }}
                          ></div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div
                  style={{
                    width: "30%",
                    //height: 200,
                    height: 200,

                    marginLeft: 20,
                    marginRight: 20,
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#fafafa",
                    justifyContent: "center",
                    //backgroundColor: "blue",
                  }}
                >
                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      width: "80%",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: 10,
                      direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontSize: 15,
                        fontFamily: "Droid Arabic Kufi, sans-serif",
                      }}
                    >
                      {t("profile.Orderprice")}
                    </p>
                    <p style={{ margin: 0, fontSize: 15 }}>
                      {/* ₪{MySaveTotalPrice.toFixed(2)} */}₪
                      {SaveTotalPrice.toFixed(2)}
                    </p>
                  </div>
                  {CheckBeautyClub ? (
                    <>
                      <div
                        style={{
                          flexDirection: "row",
                          display: "flex",
                          width: "80%",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: 10,
                          direction:
                            i18n.resolvedLanguage === "en" ? "" : "rtl",
                        }}
                      >
                        <a
                          style={{
                            fontFamily: "Droid Arabic Kufi, sans-serif",
                          }}
                        >
                          {t("profile.Beautyclubdiscount")}
                        </a>
                        <a>{BeautyClubData}%</a>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <div
                    style={{
                      height: "0.1px",
                      backgroundColor: "#e5e5e5",
                      width: "80%",
                    }}
                  ></div>
                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      width: "80%",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: 10,
                      direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    }}
                  >
                    <p style={{ margin: 0, fontWeight: "bold", fontSize: 18 }}>
                      {t("profile.Totalamount")}
                    </p>
                    {CheckBeautyClub ? (
                      <>
                        <p
                          style={{
                            margin: 0,
                            fontWeight: "bold",
                            fontSize: 18,
                          }}
                        >
                          ₪{SaveTotalPrice2.toFixed(2)}
                        </p>
                      </>
                    ) : (
                      <>
                        <p
                          style={{
                            margin: 0,
                            fontWeight: "bold",
                            fontSize: 18,
                          }}
                        >
                          ₪{SaveTotalPrice.toFixed(2)}
                        </p>
                      </>
                    )}
                  </div>
                  <div style={{ width: "80%", padding: 10, paddingTop: 20 }}>
                    <button
                      style={{
                        backgroundColor: "#27272a",
                        width: "100%",
                        height: 50,
                        color: "white",
                        borderWidth: 0,
                        fontFamily: "Droid Arabic Kufi, sans-serif",
                      }}
                      onClick={() => {
                        handleDivClick4("checkout");
                      }}
                    >
                      {t("profile.Gotopay")}
                    </button>
                  </div>
                </div>
              </div>
              {/* <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "flex-end",
                  //backgroundColor: "gray",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: 30,
                  }}
                  onClick={prev2}
                >
                  <img
                    src={arrowleft}
                    style={{
                      width: 35,
                      height: 35,
                      opacity: currentSlide2 === 0 ? 0.3 : 1,
                      cursor: currentSlide2 === 0 ? "" : "pointer",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={next2}
                >
                  <img
                    src={arrowright}
                    style={{
                      width: 35,
                      height: 35,
                      opacity: currentSlide2 === slides2.length - 1 ? 0.3 : 1,
                      cursor:
                        currentSlide2 === slides2.length - 1 ? "" : "pointer",
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  //backgroundColor: "yellow",
                  //height: "calc(100vh - 55px)",
                }}
              >
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      paddingLeft: 15,
                      fontWeight: "500",
                    }}
                  >
                    {t("profile.Recommended")}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      paddingLeft: 15,
                      fontWeight: "500",
                    }}
                  >
                    {t("profile.products")}
                  </p>
                </div>

                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      //height: "calc(100vh - 55px)",
                      direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    }}
                  >
                    <div>
                      <div ref={wrapperRef2}>
                        <Carousel
                          arrows={false}
                          infinite={false}
                          ref={carouselRef2}
                          beforeChange={handleBeforeChange2}
                          dots={false}
                        >
                          {slides2.map((slide, index) => (
                            <div>
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  //justifyContent: "space-between",
                                  justifyContent: "flex-start",
                                  width: "100%",
                                  direction:
                                    i18n.resolvedLanguage === "en" ? "" : "rtl",
                                }}
                              >
                                {slide.map((image, imgIndex) => {
                                  const globalIndex =
                                    index * numItemsPerSlide + imgIndex;
                                  return (
                                    <RecommendedProductCard
                                      key={globalIndex}
                                      id={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].id
                                      }
                                      productId={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].productId
                                      }
                                      image={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].image
                                      }
                                      title={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].name
                                      } //"Molinard Osmanthus"
                                      subtitle={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].productType
                                      } //"Eau de Parfum"
                                      price={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].price
                                      } //"₪ 19"
                                      discount={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].discount
                                      }
                                      deals={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].deals
                                      }
                                      thedeal={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].theDeal
                                      }
                                      dropDown={
                                        MyRecommendedProductsData.products[
                                          globalIndex
                                        ].dropDown
                                      }
                                    />
                                  );
                                })}
                              </div>
                            </div>
                          ))}
                        </Carousel>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </BootstrapDialog>
          </React.Fragment>
        </>
      )}
    </div>
  );
}
